import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import WeekendTrips from "./pages/WeekendTrips";
import AllTrips from "./pages/AllTrips";
import TripDetailsForm from "./pages/TripDetailsForm";
import TripsDetails from "./pages/TripsDetails";
import SpecialTripsDropDown from "./pages/SpecialTripsDropDown";
import { GoogleOAuthProvider } from "@react-oauth/google";
import BookingForm from "./pages/BookingForm";
import Profile from "./pages/Profile";
import { pdfjs } from "react-pdf";
import TermsandConditions from "./pages/TermsandCondition";
import PrivacyandPolicy from "./pages/PrivacyandPolicy";
import Gallery from "./pages/Gallery";
import BookingConfirmation from "./pages/BookingConfirmation";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contactus",
        element: <ContactUs />,
      },
      {
        path: "/tripdetailsform",
        element: <TripDetailsForm />,
      },
      {
        path: `/tripsdetails/:slug`,
        element: <TripsDetails />,
      },
      {
        path: `/profile/:id`,
        element: <Profile />,
      },
      {
        path: "/weekendtrips",
        element: <WeekendTrips />,
      },
      {
        path: "/alltrips",
        element: <AllTrips />,
      },
      {
        path: "/specialtripsdropdown",
        element: <SpecialTripsDropDown />,
      },
      {
        path: `/booknow/:slug`,
        element: <BookingForm />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/termsandconditions",
        element: <TermsandConditions />,
      },
      {
        path: "/privacyandpolicy",
        element: <PrivacyandPolicy />,
      },
      {
        path: "/gallery",
        element: <Gallery />,
      },
      {
        path: "/order-confirmation",
        element: <BookingConfirmation />,
      },
    ],
  },
]);

// const clientId = "827688853528-n9j0i6h6v98pt3rtq54r8av1dp5ogk3q.apps.googleusercontent.com";
const clientId =
  "131284245725-siod5l0jgk62ir7560h9qo9vk9dhofs3.apps.googleusercontent.com";

function App() {
  return (
    <>
      <GoogleOAuthProvider clientId="131284245725-siod5l0jgk62ir7560h9qo9vk9dhofs3.apps.googleusercontent.com">
        <RouterProvider router={router} />
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
